import React from "react";
import { Accordion, Flex, Icon } from "@telia/teddy";
import { ConnectedShoppingCart } from "../../../navigation";
import "./CartAccordion.less";

const CartAccordion: React.FC = () => (
    <Accordion type="multiple" className="cart-accordion" noborder>
        <Accordion.Item value="cart">
            <Accordion.Header className="cart-accordion__header">
                <Accordion.Trigger>
                    <Flex align="center" gapX="100">
                        <Icon size="md" name="cart" aria-hidden="true" focusable="false" />
                        Vis bestillingen din
                    </Flex>
                </Accordion.Trigger>
            </Accordion.Header>
            <Accordion.Content className="cart-accordion__content">
                <ConnectedShoppingCart useStandalone={false} />
            </Accordion.Content>
        </Accordion.Item>
    </Accordion>
);

export default CartAccordion;
